import React, { memo, useState } from 'react';
import Modal from './ui/Modal';

/**
 * Modal de confirmação de exclusão.
 *
 * Reescrito sobre o `Modal` base para herdar fechamento com Escape, retorno de
 * foco e role="dialog" — antes era um overlay solto que só respondia a clique.
 *
 * Props:
 *   titulo           — título do modal
 *   mensagem         — nó React ou string com a pergunta
 *   aviso            — consequência da ação, quando vale destacar
 *   labelConfirmar   — rótulo do botão de confirmação
 *   labelConfirmando — rótulo enquanto a ação está em andamento
 *   onConfirm        — callback ao confirmar; pode ser síncrono ou retornar promise
 *   onCancel         — callback ao cancelar / fechar
 */
const ModalConfirm = memo(function ModalConfirm({
  titulo = 'Confirmar exclusão', mensagem, aviso,
  labelConfirmar = 'Excluir', labelConfirmando = 'Excluindo...',
  onConfirm, onCancel,
}) {
  const [confirmando, setConfirmando] = useState(false);

  // Em rede lenta o produtor tocava duas vezes no botão e a exclusão saía
  // duplicada. O `await` cobre tanto o callback síncrono quanto o que devolve
  // promise, sem mudar como as telas usam o componente.
  const confirmar = async () => {
    if (confirmando) return;
    setConfirmando(true);
    try {
      await onConfirm?.();
    } finally {
      // Libera também quando falha, senão o botão fica travado sem nova tentativa.
      setConfirmando(false);
    }
  };

  return (
    <Modal titulo={titulo} onClose={onCancel} largura={440} bloqueado={confirmando}>
      <p style={{ margin: 0, color: 'var(--text)', lineHeight: 1.6, fontSize: '0.9rem' }}>{mensagem}</p>
      {aviso && (
        <p style={{ marginTop: '0.75rem', color: 'var(--danger-dark)', lineHeight: 1.5, fontSize: '0.82rem' }}>
          {aviso}
        </p>
      )}
      <div className="actions modal-rodape">
        <button type="button" className="btn-secondary" onClick={onCancel} disabled={confirmando}>Cancelar</button>
        <button type="button" className="btn-danger" onClick={confirmar} disabled={confirmando}>
          {confirmando ? labelConfirmando : labelConfirmar}
        </button>
      </div>
    </Modal>
  );
});

export default ModalConfirm;
